var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentupload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 13.92H23.1467C19.9867 13.92 17.4133 11.3467 17.4133 8.18667V4.33333C17.4133 3.6 16.8133 3 16.08 3H10.4267C6.32 3 3 5.66667 3 10.4267V22.24C3 27 6.32 29.6667 10.4267 29.6667H20.9067C25.0133 29.6667 28.3333 27 28.3333 22.24V15.2533C28.3333 14.52 27.7333 13.92 27 13.92ZM15.04 18.3733C14.84 18.5733 14.5867 18.6667 14.3333 18.6667C14.08 18.6667 13.8267 18.5733 13.6267 18.3733L12.6667 17.4133V23C12.6667 23.5467 12.2133 24 11.6667 24C11.12 24 10.6667 23.5467 10.6667 23V17.4133L9.70667 18.3733C9.32 18.76 8.68 18.76 8.29333 18.3733C7.90667 17.9867 7.90667 17.3467 8.29333 16.96L10.96 14.2933C11.0533 14.2133 11.1467 14.1467 11.2533 14.0933C11.28 14.08 11.32 14.0667 11.3467 14.0533C11.4267 14.0267 11.5067 14.0133 11.6 14C11.64 14 11.6667 14 11.7067 14C11.8133 14 11.92 14.0267 12.0267 14.0667C12.04 14.0667 12.04 14.0667 12.0533 14.0667C12.16 14.1067 12.2667 14.1867 12.3467 14.2667C12.36 14.28 12.3733 14.28 12.3733 14.2933L15.04 16.96C15.4267 17.3467 15.4267 17.9867 15.04 18.3733Z",
    fill: "#38369C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.24 11.7468C24.5067 11.7602 26.2667 11.7602 27.7734 11.7602C28.5334 11.7602 28.9334 10.8668 28.4 10.3335C26.48 8.40015 23.04 4.92015 21.0667 2.94682C20.52 2.40015 19.5734 2.77349 19.5734 3.53349V8.18682C19.5734 10.1335 21.2267 11.7468 23.24 11.7468Z",
    fill: "#38369C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentupload);
export default __webpack_public_path__ + "static/media/documentupload.e8f69452c437fc5f8ec73484a2e073c2.svg";
export { ForwardRef as ReactComponent };